import React from 'react';
import './ItemCard.css';
import Tooltip from '@mui/material/Tooltip';

const CornerDownRightIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width={16} height={16} viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth={1.5} strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-corner-down-right"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 6v6a3 3 0 0 0 3 3h10l-4 -4m0 8l4 -4" /></svg>
);
const ItemCard = ({ dimensions, type, fulfillmentLocation, fragile, single = false, name }) => (
  <div className="item-card">
    {!single && (
      <>
        <CornerDownRightIcon />
        <div className="item-card-section">
          <div className="item-card-label">Object Name</div>
          <Tooltip title={name} placement="right" arrow>
            <div id="item-name" className="item-card-value">{name}</div>
          </Tooltip>
        </div>
      </>
    )}
    <div className="item-card-section">
      <div className="item-card-label">Dimensions</div>
      <Tooltip title={dimensions} placement="right" arrow>
        <div id="item-dimensions" className="item-card-value">{dimensions}</div>
      </Tooltip>
    </div>
    <div className="item-card-section">
      <div className="item-card-label">Type</div>
      <Tooltip title={type} placement="right" arrow>
        <div id="item-type" className="item-card-value">{type}</div>
      </Tooltip>
    </div>
    { single && (
      <div className="item-card-section">
        <div className="item-card-label">Fulfillment Location</div>
        <Tooltip title={fulfillmentLocation} placement="right" arrow>
          <div id="item-fulfillment" className="item-card-value">{fulfillmentLocation}</div>
        </Tooltip>
      </div>
    )}
    <div className="item-card-section">
      <div className="item-card-label">Fragile</div>
      <Tooltip title={fragile ? 'Yes' : 'No'} placement="right" arrow>
        <div id="item-fragile" className="item-card-value">{fragile ? 'Yes' : 'No'}</div>
      </Tooltip>
    </div>
  </div>
);

export default ItemCard;
